export default class StringUtils {
    static convert = {
        camelCase: {
            toSentenceCase(str: string) {
                return str
                    .replace(/([A-Z])/g, (match) => ` ${match}`)
                    .replace(/^./, (match) => match.toUpperCase())
                    .trim();
            }
        }
    }
}